const ConfusionMatrixQuadrant = {
  TRUE_POSITIVES: 'truePositives',
  TRUE_NEGATIVES: 'trueNegatives',
  FALSE_NEGATIVES: 'falseNegatives',
  FALSE_POSITIVES: 'falsePositives',
} as const;
export type ConfusionMatrixQuadrantE = typeof ConfusionMatrixQuadrant[keyof typeof ConfusionMatrixQuadrant];

export default ConfusionMatrixQuadrant;
